import React from 'react';
import { CircularLine, FinanceCircular } from '../../types/catalog';
import { formatARS, formatPct } from '../../utils/format';
import { rateTypeLabel } from '../../utils/circular';
interface CircularTableProps {
  circular: FinanceCircular;
  lines: CircularLine[];
  selected?: {
    lineId: string;
    term: number;
  };
  onSelect?: (lineId: string, term: number) => void;
}
const coef = (n: number) => n.toLocaleString('es-AR', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
});

/** Tabla con el mismo formato de la circular oficial: monto máximo, plazo, TNA y cuota cada $1.000. */
export function CircularTable({
  circular,
  lines,
  selected,
  onSelect
}: CircularTableProps) {
  return <div className="overflow-x-auto rounded-xl border border-line" data-id="element-1093" data-mp="1t95dqyaic9au">
      <table className="w-full min-w-[560px] border-collapse text-sm" data-id="element-1094" data-mp="1tc1c2nq9ozzt">
        <caption className="sr-only" data-id="element-1095" data-mp="279zm5gxk2a9i">Líneas de financiación — {circular.reference}</caption>
        <thead data-id="element-1096" data-mp="22bohdkm4apy5">
          <tr className="bg-panel text-left text-[11px] uppercase tracking-wide text-silver" data-id="element-1097" data-mp="22c6iovnmzucx">
            <th scope="col" className="p-3 font-semibold" data-id="element-1098" data-mp="1lsbj9vwxzn4l">Máx. a financiar</th>
            <th scope="col" className="p-3 font-semibold" data-id="element-1099" data-mp="1qqd00a6wbacw">Plazo</th>
            <th scope="col" className="p-3 font-semibold" data-id="element-1100" data-mp="1vo54e3oq8oxz">TNA</th>
            <th scope="col" className="p-3 font-semibold" data-id="element-1101" data-mp="1vqr7nr4l4iae">Cuota c/ $1.000</th>
            <th scope="col" className="p-3 font-semibold" data-id="element-1102" data-mp="20pcazzf4vi32">Línea</th>
          </tr>
        </thead>
        {lines.map(line => <tbody key={line.id} className="border-t border-line" data-id="element-1103" data-mp="24nicarx7d5gl">
            {line.terms.map((row, i) => {
          const active = selected?.lineId === line.id && selected.term === row.term;
          return <tr key={row.term} onClick={onSelect ? () => onSelect(line.id, row.term) : undefined} className={`${onSelect ? 'cursor-pointer hover:bg-neon/5' : ''} ${active ? 'bg-neon/15' : ''} transition-colors duration-150`} data-id="element-1104" data-mp="2jese8ui7don6" data-mpi={i}>
                  {i === 0 && <th scope="rowgroup" rowSpan={line.terms.length} className="border-r border-line p-3 text-left align-middle font-display font-bold" data-id="element-1105" data-mp="tap3thtlqg5x">
                      {formatARS(line.maxAmount)}
                    </th>}
                  <td className="p-2.5 px-3" data-id="element-1106" data-mp="xbsg5ucfxu2e">
                    {onSelect ? <button type="button" onClick={() => onSelect(line.id, row.term)} aria-pressed={active} className={`font-semibold ${active ? 'text-neon-hi' : ''}`} data-id="element-1107" data-mp="x9xxkmon6e1h">
                        {row.term} meses
                      </button> : `${row.term} meses`}
                  </td>
                  <td className={`p-2.5 px-3 font-semibold ${row.tna === 0 ? 'text-neon-hi' : ''}`} data-id="element-1108" data-mp="1h0t87rem6jxz">{formatPct(row.tna)}</td>
                  <td className="p-2.5 px-3" data-id="element-1109" data-mp="3mszzh5edlykt">${coef(row.installmentPer1000)}</td>
                  {i === 0 && <td rowSpan={line.terms.length} className="border-l border-line p-3 align-middle" data-id="element-1110" data-mp="3it7ji7mnkq5f">
                      <p className="font-semibold" data-id="element-1111" data-mp="38pk7a6cu5ifj">{line.name}</p>
                      <p className="text-xs text-mist" data-id="element-1112" data-mp="3co9roiwak08o">{line.detail}</p>
                      <p className="mt-1 text-[11px] text-neon-hi" data-id="element-1113" data-mp="2yy6ai6c9qwq3">{rateTypeLabel(line)}</p>
                    </td>}
                </tr>;
        })}
          </tbody>)}
      </table>
    </div>;
}